export const Wrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative min-h-screen">
      <div className="absolute top-2/4 -translate-y-1/2 w-full">{children}</div>
    </div>
  );
};

export const IconWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col justify-center items-center space-x-2 space-y-2">
      {children}
    </div>
  );
};

export const InfoWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="mx-4">{children}</div>;
};

export const ButtonWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col gap-[16px] mt-[16px]">{children}</div>;
};
